__turbopack_context__.v({
  "container": "KOjI0a_container",
  "proceedButton": "KOjI0a_proceedButton",
  "proceedNote": "KOjI0a_proceedNote",
});
